import React from "react";
import CustomDialog from "../../../elements/CustomDialog";
import ProvisionLog from "./provisionLog";

const LogDetails = ({ data, onClose }) => {
  return (
    <CustomDialog
      open={Boolean(data)}
      title="Provision Logs"
      onClose={onClose}
    >
      <ProvisionLog data={data} />
    </CustomDialog>
  );
};

export default LogDetails;
